export const applicationDocsKey = 'applicationDocs';
